<template>
  <div class="productList">
    <search-com  @search-btn="searchBtn"></search-com>
    <div class="nav_box">
      <welfare-breadcrumb :itemBreadcrumb="itemBreadcrumb"></welfare-breadcrumb>
       <div class="search_box">
        <div class="search_list">
          <span>分类：</span>
          <div class="search_item_box">
            <div :class="searchType==typeItem.id?'active_item search_item':'search_item'" 
               v-for="typeItem,index in productList" :key="index" @click="chooseType(typeItem)">
            {{typeItem.name}}
          </div>
          </div>
        </div>
        <div class="search_list">
          <span>排序：</span>
          <div class="search_item_box">
            <div :class="searchTime==timeItem?'active_item search_item':'search_item'"
                v-for="timeItem,index in timeList" :key="index" @click="chooseTime(timeItem)">
            {{timeItem}}
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="product_main">
      <div class="product_list" v-if="shopProductList.length > 0">
        <div class="product_item_box" v-for="item in shopProductList" :key="item.commodityID" @click="getDetails(item)">
          <el-image
            referrerpolicy="no-referrer"
            v-if="item.commodityPictures"
            class="product_pictures"
            :src="item.commodityPictures"
            fit="fill">
          </el-image>
          <div class="product_name">{{item.goodName}}</div>
          <div class="product_information">
            <span class="product_price">￥{{item.enterprisePrice}}</span>
            <span class="product_details" @click="getDetails(item)">查看详情</span>
          </div>
        </div>
      </div>
      <div class="task-list-page" v-if="shopProductList.length > 0">
          <el-pagination
              @current-change="OnCurrentPageChanged"
              @size-change="handleSizeChange"
              :current-page="Params.PageIndex"
              :page-sizes="[20, 30, 40, 50, 60]"
              layout="prev, pager, next,sizes"
              :page-size="Params.PageSize"
              background
              :total="Params.TotalCount"
          >
          </el-pagination>
      </div>
      <section class="con-body" v-else>
      <div class="shopping_car_empty">
		  <img class="img" src="~/assets/img/welfareMall/search_bg.png" alt="">
        <div></div>
      </div>
    </section>
    </div>
  </div>

</template>

<script>
import GoodListCom from '@/components/welfareMallComp/GoodListCom'
import SearchCom from '@/components/welfareMallComp/SearchCom';
import WelfareBreadcrumb from '@/components/welfareMallComp/WelfareBreadcrumb'
import { getProductList,getProductListCommodity } from "@/network/welfareMall_api";
export default {
  name: 'productList',
  components: {
    GoodListCom,
    WelfareBreadcrumb,
    SearchCom
  },
  data() {
    return {
      itemBreadcrumb: [
        {
          name: '企业商城',
          to: '/welfareHome'
        },
        {
          name: '',
        }
      ],
      shopProductList:[],
      productList:[],// 类别
      timeList:['不限','价格优先'],
      searchType:'',
      searchTime:'',
      Params: {
        PageIndex: 1,
        PageSize: 20,
        TotalCount: 5,
        TotalPage: 0,
      },
    };
  },
  computed:{
  },
  watch:{
    "searchType":{
      handler(val){
        //console.log(val)
        this.searchType = val;
        sessionStorage.setItem('productList_typeId', val);
      },
      deep: true,
    },
    "searchTime":{
      handler(val){
        this.searchTime=val;
        sessionStorage.setItem('productList_time',val);
      }
    }
  },
  created() {
    let typeId = '';
    if(this.$route.query.typeId){
      typeId = this.$route.query.typeId;
    }else if(sessionStorage.getItem('productList_typeId')){
      typeId=sessionStorage.getItem('productList_typeId');
    }
    let typeName=sessionStorage.getItem('productList_typeName');
    let time=sessionStorage.getItem('productList_time');
    this.searchTime = time?time:'不限';
    if(typeId){
      this.searchType = typeId;
      this.itemBreadcrumb[1].name= typeName;
    }else{
      this.itemBreadcrumb[1].name='全部'
    }
    this.getProductTypeList();
    this.getShopProductList();
  },
  methods: {
    //获取商品分类
    async getProductTypeList(){
      //默认条数 100
      let res = await getProductList(100);
      if(res.isSuccess){
        this.productList = res.data;
        this.productList.unshift({id:0,name:'全部'});
      }
    },
    //选择分类
    chooseType(val){
      this.searchType = val.id;
      this.searchTime="不限";
      this.itemBreadcrumb[1].name=val.name;
      this.Params.PageIndex = 1;
      sessionStorage.setItem('productList_typeId', val.id);
      sessionStorage.setItem('productList_typeName', val.name);
      this.getShopProductList();
    },
    //选择时间
    chooseTime(val){
      this.Params.PageIndex =1;
      sessionStorage.setItem('productList_time', val);
      this.searchTime = val;
      this.getShopProductList();
    },
    //获取商品分类下的商品
    async getShopProductList(){
      let data = {
        categoryId:this.searchType,
        pageIndex:this.Params.PageIndex,
        limit:this.Params.PageSize
      }
      if(this.searchTime=="价格优先") data.order=0;
      let resList = await getProductListCommodity(data);
      if(resList.isSuccess){
        this.shopProductList =  resList.data
        this.Params.TotalCount = resList.count;
        this.Params.TotalPage = resList.count;
      }
    },
    //获取分页
    OnCurrentPageChanged(val) {
      this.Params.PageIndex = val;
      this.getShopProductList()
    },
    handleSizeChange(val) {
      this.Params.PageSize = val;
      this.getShopProductList()
    },
    // 点击搜索
    searchBtn(val){
      if(!val){
        return this.$message.info('请输入礼包名称');
      }
      document.cookie = "vueRouter="+ '/welfareSearchResult';
      this.$router.push({
        name: 'WelfareSearchResult',
        params: {
          value: val
        }
      })
    },
    
    //  跳转详情
    getDetails(item) {
      const { commodityID} = item;
      //console.log(categoryId,categoryName,commodityID)
      //缓存当前ID 刷新用到
      sessionStorage.setItem('productList_commodityID', commodityID);
      document.cookie = "vueRouter="+ '/productDetails';
      this.$router.push({
        name: 'productDetails',
        params: {commodityID}
      })
    },
  },
};
</script>

<style scoped lang="less">
.productList{
  //width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
  .nav_box{
    width:1200px;
    margin:24px auto;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 8px 24px 1px rgba(0,56,145,0.0600);
    border-radius: 16px 16px 16px 16px;
    padding:24px;
    padding-bottom: 8px;
    .search_box{
      margin-top: 30px;
      .search_list{
        span{
          float: left;
          width: 42px;
          height: 19px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          margin-top: 7px;
        }
        .search_item_box{
          margin-left: 58px;
          .search_item{
            display: inline-block;
            margin-right: 40px;
            padding:6px 12px;
            margin-bottom: 16px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            border-radius: 16px 16px 16px 16px;
          }
          .search_item:hover{
            cursor: pointer;
            background: #59B0EC;
            color:#fff;
          }
          .active_item{
            background: #0089CD;
            color: #fff;
          }
        }
      }
    }
  }
  .product_main{
    width:1200px;
    margin:0 auto;
    .product_item_box{
      display: inline-block;
      width: 282px;
      height: 365px;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #E0E0E0;
      padding:12px;
      margin-right: 24px;
      margin-bottom: 25px;
      cursor: pointer;
      .product_pictures{
        width: 258px;
        height: 258px;
      }
      .product_name{
        margin-top: 12px;
        font-size: 16px;
        font-weight: 400;
        color: #3C3C3C;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .product_information{
        margin-top: 14px;
        height: 28px;
        line-height: 28px;
        .product_price{
          font-size: 18px;
          font-weight: 400;
          color: #F5222D;
        }
        .product_details{
          float: right;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .product_item_box:nth-child(4n){
      margin-right: 0;
    }
    .task-list-page{
      text-align: center;
    }
    .con-body{
      text-align: center;
    }
  }
}
</style>
